export default __webpack_public_path__ + "static/media/Hopscotch.c69cf908.webp";